<div id="menuLocation" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <div class="header-filter-container">
      <ng-container *ngIf="webshopServiceId !==WebShopMode.Delivery">
        <div [ngClass]="needCity?'ya-input-container-flexwidth':'ya-input-container'">
          <ng-container *ngIf="autoPostalCode; then disabledSearchTemplate else regularSearchTemplate"></ng-container>
          <ng-template #disabledSearchTemplate>
            <input a11y_Input type="text" [placeholder]="setPostalCodePlaceHolder()" name="search"
              class="ya-input-text-disabled" disabled [value]="currentLocationValue()">
          </ng-template>
          <ng-template #regularSearchTemplate>
            <input a11y_Input id="locationSearcInput" type="text" [placeholder]="setPostalCodePlaceHolder()"
              class="ya-input-text" name="search" (keyup)="searchLocationFilter($event, $event.target.value)"
              (blur)="setWebView()" [value]="searchLocationKey">
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngIf="webshopServiceId === WebShopMode.Delivery && needCity">
        <div class="ya-input-container-flexwidth city-option">
          <select a11y_Select class="ya-input-text" [value]="selectedCity"
            (change)="getListByCity($event.currentTarget.value)">
            <ng-container *ngIf="!isSelectedCity">
              <option value="-1" disabled selected="true"><span langkey="ph_menuLocation_cityList"></span></option>
            </ng-container>
            <ng-container *ngFor="let city of cityList">
              <option [value]="city" [selected]="city == selectedCity">{{city}}</option>
            </ng-container>
          </select>
        </div>
      </ng-container>
      <ng-container *ngIf="webshopServiceId===WebShopMode.Delivery; then editDelivery else editDefault"></ng-container>
      <ng-template #editDelivery>
        <span>{{selectedDeliveryAddress}}</span>
        <div class="edit-plz-container">
          <a a11y_Button class="edit-plz-button" matRipple matRippleCentered="true" (click)="navigateToAddressQuery()">
            <div class="inline-icon edit-plz-svg" inlineSVG="shop-icons.svg#ya-edit_note_black"></div>
          </a>
        </div>
      </ng-template>
      <ng-template #editDefault>
        <ng-container *ngIf="autoPostalCode">
          <div class="edit-plz-container">
            <a a11y_Button class="edit-plz-button" matRipple matRippleCentered="true"
              (click)="setManualPostalcodeMode()">
              <div class="inline-icon edit-plz-svg" inlineSVG="shop-icons.svg#ya-edit_note_black"></div>
            </a>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </ya-subheader>
  <div [ngClass]="autoPostalCode ? '' : 'page-content--margin-manuallpoatalcode'"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <ng-container *ngIf="webshopServiceId === WebShopMode.Webvoucher">
      <div class="webvoucher-text">
        <h2 langkey="ph_MenuLocation_WebVoucher_Title"></h2>
        <p langkey="ph_MenuLocation_WebVoucher_SubTitle"></p>
      </div>
    </ng-container>
    <div class="ya-item-list-contaner" #locationcontainer>
      <ng-container *ngFor="let location of locationList">
        <div a11y_Button class="ya-content-item location-item" (click)="checkLocation(location)">
          <div class="location-like-wrapper">
            <ya-favoritebutton [contentType]="contentType.Location" [presentationMode]="true"
              [likeStatus]="location.like" [modelId]="location.hyp_cus_nr" [customClass]="'custom-favorite-button'">
            </ya-favoritebutton>
          </div>
          <ng-container *ngIf="!isSmallView">
            <div class="location-img">
              <div class="aspect-ration-img-box">
                <img class="ya_image" [src]="location.image_photo" alt="" />
                <div class="gradient"></div>
              </div>
            </div>
          </ng-container>
          <div class="location-content">
            <div class="location-content-wrapper">
              <div class="location-content-header">
                <h2>
                  {{location.label}}
                </h2>
              </div>
              <div class="location-content-services">
                <ng-container *ngIf="location.service_browse">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-menu"></div>
                </ng-container>
                <ng-container *ngIf="location.service_inhouse">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch"></div>
                </ng-container>
                <ng-container *ngIf="location.service_pickup">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-abholen"></div>
                </ng-container>
                <ng-container *ngIf="location.service_delivery">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-liefern"></div>
                </ng-container>
                <ng-container *ngIf="location.service_delivery_group || location.service_pickup_group">
                  <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
                </ng-container>
              </div>
            </div>
            <div class="location-content-detail-wrapper">
              <div>
                <p>{{location.street}}, {{location.zip + " " +location.location}}</p>
                <ng-container
                  *ngIf="webshopServiceId !== WebShopMode.Webvoucher && webshopServiceId !== WebShopMode.Retail && webshopServiceId !== WebShopMode.Ticket">
                  <p><span [langkey]="serviceOpenTimeTitle" class="opentimestitle"></span> <span
                      class="opentimes">{{location.openDays[0].timesToString()}}</span></p>
                </ng-container>
              </div>
              <ng-container
                *ngIf="(autoPostalCode || webshopServiceId === WebShopMode.Webvoucher || webshopServiceId === WebShopMode.TakeAway) && location.distanceString">
                <div class="location-distance">{{location.distance >= 1 ? location.distanceString : "< 1 km"}} </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>